// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const GoalAnxietyOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 96 96"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		{...props}
	>
		<defs>
			<path
				d="M63.189 53.721c0-.824-.253-2.067-1.457-3.31a2 2 0 0 0-2.873 2.784c.244.25.33.44.33.526 0 .846-3.848 3.29-11.189 3.29-7.343 0-11.19-2.444-11.19-3.29 0-.086.086-.274.328-.524a2 2 0 0 0-2.873-2.784c-1.202 1.242-1.455 2.484-1.455 3.308 0 4.785 7.641 7.29 15.19 7.29 7.547 0 15.189-2.505 15.189-7.29m-7.184-23.663a8.859 8.859 0 0 1 .941 4c0 4.932-4.014 8.945-8.946 8.945-2.39 0-4.637-.93-6.327-2.62a8.886 8.886 0 0 1-2.62-6.326c0-1.406.316-2.75.94-3.998 1.023-2.044 5.064-6.94 8.007-10.115 2.942 3.173 6.982 8.07 8.005 10.114m4.941 4c0-2.034-.458-3.982-1.363-5.79-1.596-3.189-7.555-10.015-10.169-12.629a2.002 2.002 0 0 0-2.829.001c-2.614 2.614-8.573 9.441-10.169 12.63a12.818 12.818 0 0 0-1.363 5.787c0 3.458 1.346 6.71 3.792 9.155A12.864 12.864 0 0 0 48 47.003c7.138 0 12.946-5.807 12.946-12.946m26.554 24.1c0-5.733-2.724-10.789-7.877-14.622a2 2 0 1 0-2.387 3.21c4.156 3.091 6.264 6.931 6.264 11.412 0 10.183-16.257 18.787-35.501 18.788-19.243 0-35.499-8.604-35.499-18.788 0-4.568 1.949-8.406 5.793-11.408a2 2 0 1 0-2.462-3.153C11.035 47.343 8.5 52.377 8.5 58.157c0 12.778 17.35 22.788 39.499 22.788 22.15 0 39.501-10.01 39.501-22.788M47.999 70.054c-15.476 0-27.598-6.377-27.598-14.519 0-3.348 2.138-6.537 6.021-8.976a2 2 0 1 1 2.128 3.387c-2.675 1.681-4.149 3.667-4.149 5.59 0 6.2 12.436 10.518 23.598 10.518 11.162 0 23.599-4.32 23.599-10.519 0-1.939-1.541-3.924-4.338-5.592a2 2 0 0 1 2.047-3.436c4.057 2.417 6.291 5.624 6.291 9.028 0 8.141-12.123 14.518-27.599 14.52"
				id="GoalAnxietyOutline_tsx__a"
			/>
		</defs>
		<use fill="#FFF" xlinkHref="#GoalAnxietyOutline_tsx__a" fillRule="evenodd" />
	</svg>
);
export default GoalAnxietyOutline;
